import styled from 'styled-components';

export const StyledMenuSubSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  text-transform: uppercase;
  font-family: "BebasNeue";
  margin-bottom: 24px;
  gap: 8px;

  .subsection-title {
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: center;
    font-weight: 500;
    font-size: 2em;
    line-height: 1;
    color: ${({ theme }) => theme.selection};
  }

  .subsection-title-decorator {
    height: ${({ theme }) => theme.frameWidth};
    background: ${({ theme }) => theme.selection};
    width: 16px;
    margin-right: 8px;
  }

  .subsection-title-decorator-vert {
    height: 24px;
    width: ${({ theme }) => theme.frameWidth};
    min-width: ${({ theme }) => theme.frameWidth};
    background: ${({ theme }) => theme.selection};
    margin-left: ${({ theme }) => '-' + theme.frameWidth};
  };

  .subsection-item {
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: center;
    cursor: pointer;
    gap: 8px;
    transition: color linear .2s;
    font-weight: 400;
    color: white;
    font-size: 1.5em;
    line-height: 1;

    &:hover {
      color: ${({ theme }) => theme.selection};
    }
  }

  .subsection-item-decorator {
    height: ${({ theme }) => theme.frameWidth};
    color: ${({ theme }) => theme.selection};
    width: 16px;
  }
`;

